import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Autocomplete, Chip, TextField } from "@mui/material";
import { useFormikContext } from "formik";
import React from "react";
export default function BranchMultiSelected(param) {
    var options = param.options, fieldname = param.fieldname;
    var _useFormikContext = useFormikContext(), values = _useFormikContext.values, errors = _useFormikContext.errors, setFieldValue = _useFormikContext.setFieldValue;
    return /*#__PURE__*/ _jsx(Autocomplete, {
        multiple: true,
        options: options,
        value: options.filter(function(opt) {
            return values.dimBranchIDList.includes(opt.value);
        }),
        onChange: function(e, newValue) {
            var ids = newValue.map(function(v) {
                return v.value;
            });
            setFieldValue(fieldname, ids);
        },
        renderTags: function(value, getTagProps) {
            return value.map(function(option, index) {
                return /*#__PURE__*/ _jsx(Chip, _object_spread_props(_object_spread({
                    label: option.label
                }, getTagProps({
                    index: index
                })), {
                    sx: {
                        backgroundColor: "#FFF",
                        border: "1px solid rgba(76, 78, 100, 0.22)",
                        borderRadius: "20px",
                        fontSize: "16px",
                        color: "rgba(0,0,0,0.87)",
                        maxWidth: "100%",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        padding: "20px 10px",
                        "& .MuiChip-deleteIcon": {
                            color: "red"
                        },
                        "&.Mui-disabled": {
                            opacity: 1
                        },
                        "&.Mui-disabled .MuiChip-deleteIcon": {
                            color: "gray"
                        }
                    }
                }), index);
            });
        },
        renderInput: function(params) {
            return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({}, params), {
                label: "เลือกสาขา",
                variant: "outlined",
                InputLabelProps: {
                    shrink: true
                },
                sx: {
                    "& .MuiInputBase-root": {
                        alignItems: "flex-start",
                        borderRadius: "8px"
                    },
                    "& .MuiInputBase-root.Mui-disabled": {
                        backgroundColor: "#F8F8F9"
                    }
                },
                error: Boolean(errors === null || errors === void 0 ? void 0 : errors.dimBranchIDList)
            }));
        }
    });
}
